module.exports = __webpack_public_path__ + "img/audio-cassette.437fd7b8.jpg";